// extracted by mini-css-extract-plugin
export var arrow = "CollectionTagSlider-module--arrow--ebbf1";
export var arrowNo = "CollectionTagSlider-module--arrow_no--19cd8";
export var arrowYes = "CollectionTagSlider-module--arrow_yes--c3bcb";
export var buttonWrapper = "CollectionTagSlider-module--buttonWrapper--d1dab";
export var flex = "CollectionTagSlider-module--flex--05c25";
export var flex1 = "CollectionTagSlider-module--flex_1--274e5";
export var flexCenter = "CollectionTagSlider-module--flex_center--cbcb1";
export var flexCenterCol = "CollectionTagSlider-module--flex_center_col--5a996";
export var flexCol = "CollectionTagSlider-module--flex_col--aa7b7";
export var flexFixCenterCol = "CollectionTagSlider-module--flex_fix_center_col--4356e";
export var flexFixedCenterCol = "CollectionTagSlider-module--flex_fixed_center_col--258bc";
export var left = "CollectionTagSlider-module--left--65520";
export var navigationButton = "CollectionTagSlider-module--navigationButton--05452";
export var right = "CollectionTagSlider-module--right--38302";
export var rotating = "CollectionTagSlider-module--rotating--588a0";
export var show = "CollectionTagSlider-module--show--9cc2f";
export var small = "CollectionTagSlider-module--small--1bcfe";
export var smallLeft = "CollectionTagSlider-module--smallLeft--96894";
export var smallOpacity = "CollectionTagSlider-module--smallOpacity--9d641";
export var smallRight = "CollectionTagSlider-module--smallRight--62648";
export var tag = "CollectionTagSlider-module--tag--d2f85";
export var tagSlider = "CollectionTagSlider-module--tagSlider--9b90c";
export var tagsWrapper = "CollectionTagSlider-module--tagsWrapper--4a90d";
export var tagsWrapperSmall = "CollectionTagSlider-module--tagsWrapperSmall--80953";